/** גרסת חישוב מכירות — כשמשנים חלון זמן, מטמון ישן מתרענן */
export const SALES_STATS_PERIOD_VERSION = "rolling-7d-30d-comax-sku-v2";

/** קודי item_code אפשריים לפי מוצר — תואם לשרת */
export function buildSalesItemCodeCandidates(product) {
  const codes = new Set();
  const add = (value) => {
    const s = String(value || "").trim();
    if (s) codes.add(s);
  };

  add(product?.nativId ?? product?.nativ_id);
  add(product?.externalId ?? product?.external_id);
  add(product?.barcode);

  const barcode = String(product?.barcode || "").trim();
  if (/^\d+$/.test(barcode)) {
    for (const len of [9, 8, 7, 6]) {
      if (barcode.length > len) add(barcode.slice(-len));
    }
  }

  for (const c of [...codes]) {
    if (/^0{2,}\d+$/.test(c)) {
      const stripped = c.replace(/^0+/, "");
      if (stripped.length >= 5) add(stripped);
    }
    // קומקס: מק״ט 10 + 5–7 ספרות (106760868 מול 6760868)
    if (/^10\d{5,7}$/.test(c)) {
      const rest = c.slice(2).replace(/^0+/, "");
      if (rest.length >= 5) add(rest);
    }
    if (/^\d{5,7}$/.test(c) && !c.startsWith("10")) {
      add(`10${c}`);
    }
  }

  return [...codes];
}

export function sumSalesStatsForCodes(salesByCode, codes) {
  return (codes || []).reduce(
    (acc, code) => {
      const stats = salesByCode?.[String(code)];
      if (!stats) return acc;
      acc.weekly += Number(stats.weekly || 0);
      acc.monthly += Number(stats.monthly || 0);
      return acc;
    },
    { weekly: 0, monthly: 0 }
  );
}

/** מצמיד salesStats למוצרים לפי מפת item_code מהשרת */
export function attachSalesStatsToProducts(products, salesByCode) {
  if (!products?.length) return products || [];
  const map = salesByCode && typeof salesByCode === "object" ? salesByCode : {};
  return products.map((p) => ({
    ...p,
    salesStats: sumSalesStatsForCodes(map, buildSalesItemCodeCandidates(p)),
  }));
}
